import { render, staticRenderFns } from "./FilesSidebar.vue?vue&type=template&id=3d3238e1&scoped=true"
import script from "./FilesSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesSidebar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilesSidebar.vue?vue&type=style&index=0&id=3d3238e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3238e1",
  null
  
)

export default component.exports